import {i18n} from "@/config/i18n";

export default {
  data() {
    return {
      menuOpen: false,
      observer: null,
      interestRates: [
        { level: i18n.global.t("blog.blog4.level1"), rate: '6.8%', turnover: 'X ≥ 15', percentage: 100, isHighlighted: true },
        { level: i18n.global.t("blog.blog4.level2"), rate: '8.9%', turnover: '11 ≤ X < 15', percentage: 80, isHighlighted: false },
        { level: i18n.global.t("blog.blog4.level3"), rate: '10.05%', turnover: '8 ≤ X < 11', percentage: 60, isHighlighted: false },
        { level: i18n.global.t("blog.blog4.level4"), rate: '11.0%', turnover: '5 ≤ X < 8', percentage: 40, isHighlighted: false },
        { level: i18n.global.t("blog.blog4.level5"), rate: '13.0%', turnover: '2 ≤ X < 5', percentage: 20, isHighlighted: false },
        { level: i18n.global.t("blog.blog4.level6"), rate: i18n.global.t("blog.blog4.followService"), turnover: 'X < 2', percentage: 10, isHighlighted: false }
      ],
      features: [
        {
          icon: 'fas fa-chart-line',
          title: i18n.global.t("blog.blog4.preferentialInterestRates"),
          description: i18n.global.t("blog.blog4.from68")
        },
        {
          icon: 'fas fa-coins',
          title: i18n.global.t("blog.blog4.notMin"),
          description: i18n.global.t("blog.blog4.notTran")
        },
        {
          icon: 'fas fa-calendar-check',
          title: i18n.global.t("blog.blog4.free"),
          description: i18n.global.t("blog.blog4.free1")
        },
        {
          icon: 'fas fa-mobile-alt',
          title: i18n.global.t("blog.blog4.registEasy"),
          description: i18n.global.t("blog.blog4.registChannel")
        }
      ],
      faqs: [
        {
          question: i18n.global.t("blog.blog4.q1"),
          answer: i18n.global.t("blog.blog4.a1"),
          isOpen: false
        },
        {
          question: i18n.global.t("blog.blog4.q2"),
          answer: i18n.global.t("blog.blog4.a2"),
          isOpen: false
        },
        {
          question: i18n.global.t("blog.blog4.q3"),
          answer: i18n.global.t("blog.blog4.a3"),
          isOpen: false
        },
        {
          question: i18n.global.t("blog.blog4.q4"),
          answer: i18n.global.t("blog.blog4.a4"),
          isOpen: false
        }
      ]
    };
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.initializeAnimations();
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    selectRate(index) {
      this.interestRates.forEach((rate, i) => {
        rate.isHighlighted = i === index;
      });
    },
    toggleFAQ(index) {
      this.faqs[index].isOpen = !this.faqs[index].isOpen;
    },
    goToContact() {
      this.$router.push('/contact');
    },
    initializeAnimations() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("visible");

              const delay =
                Array.from(entry.target.parentNode.children).indexOf(entry.target) * 100;
              setTimeout(() => {
                entry.target.style.transitionDelay = `${delay}ms`;
              }, 0);
            }
          });
        },
        {
          threshold: 0.1,
          rootMargin: "0px 0px -50px 0px",
        }
      );

      this.$nextTick(() => {
        const animatedElements = document.querySelectorAll(".animate-on-scroll");
        animatedElements.forEach((el) => {
          this.observer.observe(el);
        });
      });
    }
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
};